<template>
  <div class="page page-app">
    <img class="page-banner" src="../../assets/banners/hsl.jpeg">
    <div class="page-header">
        <div>
            <h2><WFTranslate k="hsl-app">Lataa HSL -sovellus</WFTranslate></h2>
            <img class="page-image" src="../../assets/pages/hsl.png">
        </div>
    </div>
    <div class="page-description">
        <WFTranslate k="hsl-app-description"></WFTranslate>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    watch: {
        page () {
            console.log('page', this.page)
        }
    },
    mounted () {
        console.log('page2', this.page)
    }
}
</script>

<style lang="less">

</style>